// extracted by mini-css-extract-plugin
module.exports = {"newAddress":"NewAddressOption__newAddress___YgngH"};